export default __webpack_public_path__ + "static/GT-Super-Display-Super-Italic-aabf4bd6a3bb4fa29d45df71656ca473.woff2";